import PropTypes from "prop-types"
import React from "react"
import Relay from "react-relay"
import classNames from "classnames"
import ImgSrcSet from "../elements/ImgSrcSet"
import DeepZoom from "../elements/DeepZoom"
import {
  createSrcSetForResource,
  createSrcSetForFile,
  getImageSrcFromResource,
  getImageSrcFromFile,
  getImageType,
  getDeepZoomSrcFromResource,
  getDeepZoomSrcFromFile
} from "../../scripts/resource"
import Image from "../elements/Image"

class ImageView extends React.Component {
  static propTypes = {
    withDeepZoom: PropTypes.bool,
    withSchemaUrl: PropTypes.bool
  }
  static defaultProps = {
    withDeepZoom: true,
    withSchemaUrl: true,
    ifNoImage: null
  }

  render() {
    const { resource, file } = this.props
    const {
      imgClassName,
      withDeepZoom,
      withSchemaUrl,
      ifNoImage,
      ...props
    } = this.props

    const imageType = getImageType(file ? file.type : resource.type)
    const imageSrc = file
      ? getImageSrcFromFile(file, "medium", imageType, false)
      : getImageSrcFromResource(resource, "medium", imageType, false)
    const srcSet = file
      ? createSrcSetForFile(file, imageType)
      : createSrcSetForResource(resource, imageType)
    const deepZoomUrl =
      withDeepZoom &&
      (file
        ? getDeepZoomSrcFromFile(file)
        : getDeepZoomSrcFromResource(resource))
    const title =
      props.title || (resource && resource.title) || (file && file.title)

    return (
      <div>
        {imageSrc && <Image className="show-for-print" src={imageSrc} />}
        {imageSrc &&
          withSchemaUrl && (
            <span className="hide for-schema-markup-only" itemProp="url">
              {imageSrc}
            </span>
          )}

        {deepZoomUrl && <DeepZoom url={deepZoomUrl} />}
        {!deepZoomUrl &&
          imageSrc && (
            <ImgSrcSet
              alt={title}
              src={imageSrc}
              srcSet={srcSet}
              className={classNames("c-mviewer__object", imgClassName)}
            />
          )}

        {!imageSrc && ifNoImage !== null && ifNoImage}
      </div>
    )
  }
}

export default Relay.createContainer(ImageView, {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
      type
      title
      files {
        type
        images {
          small { url height width }
          medium { url height width }
          large { url height width }
          original { url height width }
        }
        deep_zoom { url }
      }
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ImageView.js